import { Box } from '@chakra-ui/react';
import React from 'react';

interface RequiredMarkProps {
    withDescription?: boolean;
}

const RequiredMark: React.FC<RequiredMarkProps> = (props) => {
  return (
    <>
        {props.withDescription ? (
            <Box fontSize="xs" textAlign="start" mt="5">
                <span className='required-mark'> * pola wymagane</span>
            </Box>
        ) : (
            <span className='required-mark'> *</span>
        )}
    </>
  );
};

export default RequiredMark;